'use client'

import { useDispatch, useSelector } from 'react-redux'
import CloseSharpIcon from '@mui/icons-material/CloseSharp'
import { useOnClickOutside } from 'usehooks-ts'
import { useRef } from 'react'
import { closeModal, setModal } from '@/redux/features/modalSlice'
import styles from './Modal.module.scss'
import { AnimatePresence, motion } from 'framer-motion'

export const useModal = () => {
    let modal = useSelector((state: any) => state.modal)
    let dispatch = useDispatch()

    const handleModalChange = data => {
        if (data) {
            dispatch(setModal(data))
        } else {
            dispatch(closeModal())
        }
    }

    return [modal, handleModalChange]
}

const Modal = () => {
    const [modal, setModal] = useModal()
    const ref = useRef(null)

    const handleClickOutside = () => {
        setModal(false)
    }

    useOnClickOutside(ref, handleClickOutside)

    return (
        <AnimatePresence>
            <motion.div
                animate={{ opacity: 1 }}
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
            >
                <motion.div
                    animate={{ y: -20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    exit={{ y: 20, opacity: 1 }}
                    className={styles.modalWrapper}
                    style={modal !== false ? { display: 'flex' } : { display: 'none' }}
                >
                    <div>
                        {modal}
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    )
}

export default Modal
